import * as React from 'react';
import { Route, Redirect } from 'react-router-dom';
import { ProfileContext, ProfileManager } from '../profile';

export interface AuthProps {
  component: any;
  path: string;
}

const isLoggedIn = (context: ProfileManager): boolean => {
  return context.profile !== null;
};

export default function AuthRoute({
  component: Component,
  ...props
}: AuthProps) {
  const context = React.useContext(ProfileContext);

  return (
    <Route
      {...props}
      render={(props) =>
        isLoggedIn(context) ? (
          <Component {...props} />
        ) : (
          <Redirect
            to={{ pathname: '/login', state: { from: props.location } }}
          />
        )
      }
    />
  );
}
